import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useProviderMappingsSelection} from '../hooks/useProviderMappingsSelection';
import {deleteProviderMappingWithSync} from '../services/ProviderMappingsService';
import {notifySuccess, notifyError} from '../../../components/ServiceNotifications';

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useProviderMappingsSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => 
                deleteProviderMappingWithSync({
                    id: record.id,
                    billingProviderId: record.billingProviderId,
                    providerEntityId: record.providerEntityId,
                    entityType: record.entityType,
                    localEntityId: record.localEntityId
                })
            ));
            clearSelection();
        },
        onSuccess: () => {
            notifySuccess('Provider mapping deleted successfully');
            queryClient.invalidateQueries({queryKey: ['provider-mappings']});
        },
        onError: (error) => {
            notifyError(error);
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};